import { addUnhandledRejectionEventListeners } from './modules/addUnhandledRejectionEventListeners';
import { addErrorEventListeners } from './modules/addErrorEventListeners';

const addEventListeners = () => {
  addUnhandledRejectionEventListeners();
  addErrorEventListeners();
};

export { addEventListeners };
